module.exports = __webpack_public_path__ + "files/29845c701c8ec7b30f00514ca4aee03a.png";